module.exports = __webpack_public_path__ + "static/media/arrows.b19091a0.svg";